import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import * as moment from 'moment';
import { ILeadResource } from 'common/interfaces/resources';
import { IconButton } from 'components/action';

// Styles
const s = require('./Resource.css');
const deleteIcon = require('assets/close orange icon.svg');
const fileBoxCorner = require('assets/filetypes/file corner.png');
const docIcon = require('assets/filetypes/office word icon.svg');
const excelIcon = require('assets/filetypes/office excel icon.svg');
const powerpointIcon = require('assets/filetypes/office powerpoint icon.svg');
const pdfIcon = require('assets/filetypes/acrobat icon.svg');
const imageIcon = require('assets/filetypes/image icon.svg');
const anyfileIcon = require('assets/filetypes/other format icon.svg');

// Props
interface IResourceProps {
    resource: ILeadResource;
    editing?: boolean;
    onDelete?: (resourceId: number) => void;
}

// Component
@observer
export class Resource extends React.Component<IResourceProps, {}> {
    static get defaultProps(): IResourceProps {
        return {
            resource: null,
            editing: false,
            onDelete: null,
        };
    }

    constructor(props: IResourceProps) {
        super(props);
    }

    @computed private get icon(): string| null {
        let icon = null;

        switch (this.props.resource.fileType) {
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
            case 'application/vnd.ms-word.document.macroEnabled.12':
            case 'application/vnd.ms-word.template.macroEnabled.12':
            case 'application/rtf':
                icon = docIcon;
                break;

            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
            case 'application/vnd.ms-excel.sheet.macroEnabled.12':
            case 'application/vnd.ms-excel.template.macroEnabled.12':
            case 'application/vnd.ms-excel.addin.macroEnabled.12':
            case 'application/vnd.ms-excel.sheet.binary.macroEnabled.12':
            case 'text/csv':
                icon = excelIcon;
                break;

            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            case 'application/vnd.openxmlformats-officedocument.presentationml.template':
            case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
            case 'application/vnd.ms-powerpoint.addin.macroEnabled.12':
            case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
            case 'application/vnd.ms-powerpoint.template.macroEnabled.12':
            case 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12':
                icon = powerpointIcon;
                break;

            case 'application/pdf':
                icon = pdfIcon;
                break;

                case 'image/gif':
                case 'image/x-icon':
                case 'image/jpeg':
                case 'image/jpg':
                case 'image/png':
                case 'image/svg':
                case 'image/svg+xml':
                case 'image/tiff':
                case 'image/webp':
                case 'image/bmp':
                icon = imageIcon;
                break;

                default:
                icon = anyfileIcon;
                break;
        }

        return icon;
    }

    public render() {
        const { fileTitle, fileName, fileLink, updatedAt } = this.props.resource;

        return (
            <div className={s.resource}>
                <a href={fileLink} className={s.box}>
                    <img className={s.icon} src={this.icon} />
                    <img className={s.corner} src={fileBoxCorner} />
                </a>
                <div className={s.description}>
                    <a href={fileLink} className={s.name}>{fileTitle || fileName}</a>
                    <p className={s.date}>{moment(updatedAt).format('M/DD/YYYY')}</p>
                </div>
                {(this.props.editing) && (
                    <div className={s.delete}>
                        <IconButton
                            onClick={this.handleResourceRemoval}
                            label="Delete"
                            showLabel={true}
                            icon={deleteIcon}
                            labelOnRight={false}
                        />
                    </div>
                )}
            </div>
        );
    }

    private handleResourceRemoval = () => {
        if (this.props.onDelete) {
            this.props.onDelete(this.props.resource.id);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Resources/Resource/Resource.tsx